import React, { useContext } from 'react';
import { EditorBinding, EditorContext } from '../../../utils/contexts';
import CollapsedPanel from '../components/CollapsedPanel';
import Switcher from '../components/Switcher';
import { Label } from '../Steps/components';
import SubheadlineQuill from '../components/SubheadlineQuill';

export default function Subheadline2Panel() {
  const { settings, updateSettings } = useContext(EditorContext);

  const toggleHide = () => {
    updateSettings({ show_optional_content: !settings.show_optional_content });
  };

  const editorBindings = useContext(EditorBinding);
  const isTechAdvisorPlus = settings.theme_id === 'tech-advisor-plus';

  return (
    <CollapsedPanel
      open={editorBindings.showContent}
      title="Subheadline 2"
      allowed={true}
    >
      <Label>
        <span>Show</span>
        <Switcher
          checked={settings.show_optional_content}
          onChange={toggleHide}
        />
      </Label>
      {settings.show_optional_content && isTechAdvisorPlus && (
        <SubheadlineQuill
          value={settings.content}
          onChange={(content) => updateSettings({ content })}
        />
      )}
    </CollapsedPanel>
  );
}
